module.exports = __webpack_public_path__ + "static/media/surds_tri.2607f4f4.jpg";